import $ from '@vaersaagod/tools/Dom';
import Dispatch from '@vaersaagod/tools/Dispatch';
import agent from '@vaersaagod/tools/request';
import serialize from 'form-serialize';
import * as Events from '../lib/events';

export default el => {
    const form = $(el);
    const button = form.find('[data-submit]');

    const resetForm = () => {
        button.attr('disabled', null);
        form.removeClass('invalid');
        el.reset();
    };

    const submitForm = () => {
        const params = serialize(el);
        button.attr('disabled', '');
        agent
            .post('/')
            .accept('application/json')
            .send(params)
            .end((error, res) => {
                const response = JSON.parse(res.text);
                if (error || !response.status) {
                    Dispatch.emit(Events.DIALOG_OPEN, {
                        heading: 'Uff-da!',
                        ingress: 'Her gikk visst noe galt',
                        text: 'Lorem ipsum dolores'
                    });
                } else {
                    Dispatch.emit(Events.DIALOG_OPEN, response);
                }
            });
    };

    const init = () => {
        Dispatch.on(Events.DIALOG_CLOSE, resetForm);

        if ('checkValidity' in el) {
            form.attr('novalidate', '');
            form.on('submit', e => {
                e.preventDefault();
                if (!el.checkValidity()) {
                    form.addClass('invalid');
                    const firstInvalidField = form.find('*:invalid:not(fieldset)').first();
                    const offset = firstInvalidField.offset().top - 60;
                    TweenLite.to(window, 0.65, { scrollTo: { y: offset, autoKill: false },
                        ease: Cubic.easeInOut,
                        onComplete() {
                            firstInvalidField.focus();
                        } });
                } else {
                    submitForm();
                }
            });
        }
    };

    const destroy = () => {
        Dispatch.off(Events.DIALOG_CLOSE, resetForm);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/CreateJobForm.js